 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTGHPPE_FR from '@/components/Text/GHPPe_fr'
 import LOVE_1 from '@/components/love_1'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
 import TEXTSECTION0004 from '@/components/Text/Section0004'
 import TEXTSECTION0002 from '@/components/Text/Section0002'
 import TEXTSECTION0006 from '@/components/Text/Section0006'
 import TEXTSECTION0003 from '@/components/Text/Section0003'
 import TEXTGHPPE_ACK from '@/components/Text/GHPPe_ack'
 import TEXTGHPPE_INT from '@/components/Text/GHPPe_int'
 import TEXTGHPPE_1 from '@/components/Text/GHPPe_1'
 import TEXTSECTION0005 from '@/components/Text/Section0005'
 import TEXTGHPPE_2 from '@/components/Text/GHPPe_2'
 import TEXTGHPPE_3 from '@/components/Text/GHPPe_3'
 import TEXTGHPPE_4 from '@/components/Text/GHPPe_4'
 import TEXTGHPPE_5 from '@/components/Text/GHPPe_5'
 import TEXTGHPPE_6 from '@/components/Text/GHPPe_6'
 import LOVE_2 from '@/components/love_2'
 import TEXTGHPPE_APXA from '@/components/Text/GHPPe_apxa'
 import TEXTGHPPE_APXB from '@/components/Text/GHPPe_apxb'
 import TEXTGHPPE_APXC from '@/components/Text/GHPPe_apxc'
 import TEXTGHPPE_APXD from '@/components/Text/GHPPe_apxd'
 import TEXTGHPPE_APXE from '@/components/Text/GHPPe_apxe'
 import TEXTGHPPE_APXF from '@/components/Text/GHPPe_apxf'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/GHPPe_fr",
 			"name" : "Text/GHPPe_fr",
 			"component" : TEXTGHPPE_FR
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/Section0001",
 			"name" : "Text/Section0001",
 			"component" : TEXTSECTION0001
 		},
 		{
 			"path" : "/Text/Section0004",
 			"name" : "Text/Section0004",
 			"component" : TEXTSECTION0004
 		},
 		{
 			"path" : "/Text/Section0002",
 			"name" : "Text/Section0002",
 			"component" : TEXTSECTION0002
 		},
 		{
 			"path" : "/Text/Section0006",
 			"name" : "Text/Section0006",
 			"component" : TEXTSECTION0006
 		},
 		{
 			"path" : "/Text/Section0003",
 			"name" : "Text/Section0003",
 			"component" : TEXTSECTION0003
 		},
 		{
 			"path" : "/Text/GHPPe_ack",
 			"name" : "Text/GHPPe_ack",
 			"component" : TEXTGHPPE_ACK
 		},
 		{
 			"path" : "/Text/GHPPe_int",
 			"name" : "Text/GHPPe_int",
 			"component" : TEXTGHPPE_INT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js